{
  "jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.email.body.address": [
    {
      "type": 0,
      "value": "341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.email.body.copyright": [
    {
      "type": 0,
      "value": "Copyright "
    },
    {
      "type": 1,
      "value": "year"
    },
    {
      "type": 0,
      "value": " Atlassian Pty Ltd. All rights reserved."
    }
  ],
  "jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.email.body.cta.shift-details": [
    {
      "type": 0,
      "value": "View shift details"
    }
  ],
  "jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.email.body.cta.work-items": [
    {
      "type": 0,
      "value": "View work items"
    }
  ],
  "jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.email.body.heading": [
    {
      "type": 0,
      "value": "Your shift in "
    },
    {
      "type": 1,
      "value": "scheduleName"
    },
    {
      "type": 0,
      "value": " starts in "
    },
    {
      "type": 1,
      "value": "leadMinutes"
    },
    {
      "type": 0,
      "value": " minutes"
    }
  ],
  "jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.email.body.preferences": [
    {
      "type": 0,
      "value": "Manage notifications for your schedules"
    }
  ],
  "jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.email.body.shift-ends.label": [
    {
      "type": 0,
      "value": "Shift ends:"
    }
  ],
  "jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.email.body.shift-starts.label": [
    {
      "type": 0,
      "value": "Shift starts:"
    }
  ],
  "jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.message-template.email.subject": [
    {
      "type": 0,
      "value": "Your shift in "
    },
    {
      "type": 1,
      "value": "scheduleName"
    },
    {
      "type": 0,
      "value": " starts soon"
    }
  ],
  "jsm-project-summary-onboarding.changeLayout": [
    {
      "type": 0,
      "value": "Change the layout and order of charts"
    }
  ],
  "jsm-project-summary-onboarding.closeButton": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "jsm-project-summary-onboarding.description": [
    {
      "type": 0,
      "value": "You can now edit the summary page to keep your team up to date. Tailor your space overview by customizing the layout, filters, and charts."
    }
  ],
  "jsm-project-summary-onboarding.editFilters": [
    {
      "type": 0,
      "value": "Edit filters"
    }
  ],
  "jsm-project-summary-onboarding.heading": [
    {
      "type": 0,
      "value": "Edit your space summary"
    }
  ],
  "jsm-project-summary-onboarding.hideAddCharts": [
    {
      "type": 0,
      "value": "Hide or add charts"
    }
  ],
  "jsm-project-summary-onboarding.moreAboutFeature": [
    {
      "type": 0,
      "value": "More about space summary"
    }
  ],
  "jsm-project-summary-onboarding.okButton": [
    {
      "type": 0,
      "value": "Got it"
    }
  ],
  "jsm-project-summary-onboarding.whatsNewTitle": [
    {
      "type": 0,
      "value": "What’s new?"
    }
  ]
}